<div mat-dialog-title class=" bg-accent-light  pad-8-top pad-8-bottom text-center font-16 font-bold display-flex">
    <div class="flex-1 text-accent" >{{dialogData.heading}}</div>
    <mat-icon *ngIf="dialogData.enableClose" class="cursor-pointer text-dark font-16 pad-4-top pad-8-right" (click)="close(dialogCloseReason.noAction)">close</mat-icon>
</div>
<mat-dialog-content class="no-padding no-margin verify-dialog-content">
    <div class="fill-height flex-centered-container-column text-center padding-hr">
        <img [src]="dialogData.image" alt="money">
        <div class="text-accent margin-top font-16 font-bold">{{dialogData.text1}}</div>
        <div class="margin-top margin-bottom font-12" [innerHTML]="dialogData.text2"></div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="verify-dialog-actions">
    <div class="flex-centered-container-column full-width">
        <button [ngClass]="dialogData.isBtnAccent ?  'bg-accent-darker' : 'bg-warn-dark'" (click)="close(dialogCloseReason.primaryAction)" mat-flat-button>{{dialogData.btn1Text}}</button>
        <button mat-button (click)="close(dialogCloseReason.secondaryAction)" >{{dialogData.btn2Text}}</button>
    </div>
</mat-dialog-actions>